import React from 'react';
import { isDarkMode } from 'utils/helpers';

const styles = {
  cursor: 'pointer',
  color: isDarkMode() ? '#CAE3F5' : '#8392A7',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: '17px',
  textDecoration: 'none',
};

interface IJoinButtonActionProps {
  buttonType?: string;
  onClick?: (event: React.MouseEvent) => void;
  label: string;
  dataTestId?: string;
  customWrapperStyle?: React.CSSProperties;
  customStyle?: React.CSSProperties;
}

const JoinSkipButton: React.FC<IJoinButtonActionProps> = (props: IJoinButtonActionProps) => {
  const { customStyle, onClick, label, customWrapperStyle, dataTestId } = props;

  return (
    <div style={customWrapperStyle}>
      <a onClick={onClick} style={{ ...styles, ...customStyle }} data-test-id={dataTestId}>
        {label}
      </a>
    </div>
  );
};

export default JoinSkipButton;
